import { ref, watch } from 'vue'
import { useDebounceFn } from '@vueuse/core'

export function useSearch() {
  const inputRef = ref(null)

  const query = ref('')

  function clearQuery() {
    query.value = ''
  }

  function watchQuery(fn: Function) {
    watch(query, useDebounceFn(fn, 300))
  }

  return {
    inputRef,

    query,
    clearQuery,
    watchQuery,
  }
}
